import React, { useState, useEffect } from 'react'
import 'react-calendar/dist/Calendar.css';
import "./calender_styles/calender.css";
import "./calender_styles/custom_calender.css";
import Calendar from 'react-calendar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesDown, faAnglesUp, faDeleteLeft, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import swal2 from 'sweetalert2';
import { useSelector } from 'react-redux';
import Pikaday from 'pikaday';
import { tasksRef } from '../../firebase';
import EventsHolidaysData from "./EventsHoldiday2023.json";


// get current date form of -> [Sunday, 16 Apr 2023]
const getCurrentDate = () => {
    const date = new Date();
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const dayOfWeek = weekdays[date.getDay()];
    const formattedDate = `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    return [dayOfWeek, formattedDate];
}


// Add New Task button 
const handleAddTask = (usersData) => {
    let datepicker;

    swal2.fire({
        title: 'Please enter',
        html: `
            <input id="datepicker" class="swal2-input" placeholder="Date">
            <input id="task_name" class="swal2-input" placeholder="Task Name">
            <input id="task_desc" class="swal2-input" placeholder="Task Description">
        `,
        inputValue: new Date().toISOString(),
        stopKeydownPropagation: false,
        showCloseButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        preConfirm: () => {
            const taskName = document.getElementById('task_name').value;
            const taskDesc = document.getElementById('task_desc').value;
            const selectedDate = datepicker.getDate();

            if (!taskName || !taskDesc || !selectedDate) {
                swal2.showValidationMessage('All fields are required');
            }

            if (selectedDate < new Date(new Date().setHours(0, 0, 0, 0))) {
                swal2.showValidationMessage(`Date can't be in the past`);
            }
            return { taskName, taskDesc, selectedDate };
        },
        didOpen: () => {
            datepicker = new Pikaday({ field: document.getElementById('datepicker') });
            setTimeout(() => datepicker.show(), 400); // show calendar after showing animation
        },
        didClose: () => {
            datepicker.destroy();
        },
    }).then(async (result) => {
        if (result.isConfirmed && result.value) {
            await tasksRef.add({
                status: "next_up",
                date: result.value.selectedDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
                task_name: result.value.taskName,
                task_desc: result.value.taskDesc,
                email_id: usersData.email
            })
                .then(() => {
                    swal2.fire({
                        icon: 'success',
                        title: 'New task is added!',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }).catch((error) => {
                    // console.log(error);
                    swal2.fire({
                        icon: 'error',
                        title: 'An error occurred while adding the task.',
                        showConfirmButton: false,
                        timer: 1500
                    })
                });
        }
    });
}



// change the state of task - progress
const handleTaskProgress = async (task_id, taskStatus) => {
    await tasksRef.doc(task_id).set({
        status: taskStatus
    }, { merge: true })
        .then(() => {
            swal2.fire({
                icon: 'success',
                title: `Your new task is ${taskStatus}!`,
                showConfirmButton: false,
                timer: 1500
            })
        }).catch((error) => {
            swal2.fire({
                icon: 'error',
                title: `An error occurred while adding the task ${taskStatus}.`,
                showConfirmButton: false,
                timer: 1500
            })
        });
}


// Edit the task 
const handleTaskEdit = (taskId, taskData) => {
    let datepicker;

    swal2.fire({
        title: 'Edit Task',
        html: `
        <input id="datepicker" class="swal2-input" placeholder="Date" value="${taskData.date}">
        <input id="task_name" class="swal2-input" placeholder="Task Name" value="${taskData.task_name}">
        <input id="task_desc" class="swal2-input" placeholder="Task Description" value="${taskData.task_desc}">
      `,
        inputValue: new Date().toISOString(),
        stopKeydownPropagation: false,
        showCloseButton: true,
        preConfirm: () => {
            const taskName = document.getElementById('task_name').value;
            const taskDesc = document.getElementById('task_desc').value;
            const selectedDate = datepicker.getDate();

            if (!taskName || !taskDesc || !selectedDate) {
                swal2.showValidationMessage('All fields are required');
            }

            if (selectedDate < new Date(new Date().setHours(0, 0, 0, 0))) {
                swal2.showValidationMessage(`Date can't be in the past`);
            }

            return { taskName, taskDesc, selectedDate };
        },
        didOpen: () => {
            datepicker = new Pikaday({ field: document.getElementById('datepicker') });
            setTimeout(() => datepicker.show(), 400); // show calendar after showing animation
        },
        didClose: () => {
            datepicker.destroy();
        },
    }).then(async (result) => {
        if (result.isConfirmed && result.value) {
            await tasksRef.doc(taskId).update({
                date: result.value.selectedDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
                task_name: result.value.taskName,
                task_desc: result.value.taskDesc,
            })
                .then(() => {
                    swal2.fire({
                        icon: 'success',
                        title: `Task is Updated!`,
                        showConfirmButton: false,
                        timer: 1500
                    })
                }).catch((error) => {
                    swal2.fire({
                        icon: 'error',
                        title: `An error occurred while updating the task!`,
                        showConfirmButton: false,
                        timer: 1500
                    })
                });
        }
    });
}


// Delete task 
const handleTaskDelete = async (task_id) => {
    swal2.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this task!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel plx!"
    }).then((result) => {
        if (result.isConfirmed) {
            // Here, you can add code to delete the document
            tasksRef.doc(task_id).delete().then(() => {
                swal2.fire({
                    icon: 'success',
                    title: `Your task has been deleted.!`,
                    showConfirmButton: false,
                    timer: 1500
                })
            }).catch((error) => {
                swal2.fire({
                    icon: 'error',
                    title: `An error occurred while deleting the task!`,
                    showConfirmButton: false,
                    timer: 1500
                })
            });
        } else {
            swal2.fire({
                icon: 'error',
                title: `Your task is safe.`,
                showConfirmButton: false,
                timer: 1500
            })
        }
    });
}


// Task Board Component 
const CalenderPage = () => {
    const [date, setDate] = useState(new Date());
    const [tasksOpenState, settasksOpenState] = useState(false);
    const handleTasksOpen = () => {
        if (tasksOpenState) {
            settasksOpenState(false);
        } else {
            settasksOpenState(true);
        }
    }
    const [dayOfWeek, formattedDate] = getCurrentDate();
    const [ActiveTaskProgressBar, setActiveTaskProgressBar] = useState("next_up");
    const usersData = useSelector((state) => state.userData);
    const [taskData, setTaskData] = useState([]);
    const [tasksCount, setTasksCount] = useState({
        tasksCompletedCount: 0,
        tasksInProgressCount: 0,
        tasksNextUpCount: 0
    })
    const [calenderSubHearderState, setCalenderSubHearderState] = useState("holidays");
    const [currentMonth, setCurrentMonth] = useState(date.getMonth() + 1);
    const [eventsHodidays, setEventsHolidays] = useState([]);


    // fetch the tasks and fiter with status
    useEffect(() => {
        tasksRef
            .where('email_id', '==', usersData.email)
            .onSnapshot(snapshot => {
                const tasksArray = snapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }))

                const completedTasksArray = tasksArray.filter(task => task.data.status === 'Completed');
                const inProgressTasksArray = tasksArray.filter(task => task.data.status === 'In Progress');
                const nextUpTasksArray = tasksArray.filter(task => task.data.status === 'next_up');

                setTasksCount({
                    ...tasksCount, tasksCompletedCount: completedTasksArray.length,
                    tasksInProgressCount: inProgressTasksArray.length,
                    tasksNextUpCount: nextUpTasksArray.length
                })

                // console.log(completedTasksArray, inProgressTasksArray, nextUpTasksArray);

                if (ActiveTaskProgressBar === 'Completed') {
                    setTaskData(completedTasksArray);
                } else if (ActiveTaskProgressBar === 'In Progress') {
                    setTaskData(inProgressTasksArray);
                } else if (ActiveTaskProgressBar === 'next_up') {
                    setTaskData(nextUpTasksArray);
                }
            })
        // eslint-disable-next-line
    }, [usersData.email, ActiveTaskProgressBar]);


    // fetch events and holidays 
    useEffect(() => {
        const filteredData = EventsHolidaysData.filter((data) => {
            // eslint-disable-next-line
            const [date, month, year] = data.Date.split('-'); // Split date string into parts using '-'
            return parseInt(month) === currentMonth; // Return true if month matches current month
        });
        setEventsHolidays(filteredData);
    }, [currentMonth]);



    // console.log(eventsHodidays);

    return (
        <>
            <div className='calender_page_container'>
                <div className='task_board_container'>
                    <div className='task_board_header'>
                        <div>
                            <h2 className='task_title'>Task Board</h2>
                            <p className='meeting_card_time'><span>{dayOfWeek},</span> {formattedDate}</p>
                        </div>
                        <div className='add_task'>
                            <span className='add_task_button' onClick={() => {
                                handleAddTask(usersData);
                                setActiveTaskProgressBar("next_up");
                            }}>Add Task</span>
                        </div>
                    </div>
                    <div className={`task_container ${tasksOpenState ? "" : "tasksCloseState"}`}>
                        <div className='task_sub_headers_container'>
                            <p className='calender_sub_header downArrowIcon' onClick={handleTasksOpen} style={{ display: tasksOpenState ? "none" : "" }}><FontAwesomeIcon icon={faAnglesDown} /></p>
                            <p className='calender_sub_header downArrowIcon' onClick={handleTasksOpen} style={{ display: tasksOpenState ? "" : "none" }}><FontAwesomeIcon icon={faAnglesUp} /></p>

                            <p className={` calender_sub_header cal_sub_hd ${ActiveTaskProgressBar === "next_up" ? "activeCalenderSubHeader" : ""}`} onClick={() => setActiveTaskProgressBar('next_up')}>Next Up<span className='sub_header_count'>{tasksCount.tasksNextUpCount}</span></p>
                            <p className={` calender_sub_header cal_sub_hd ${ActiveTaskProgressBar === "In Progress" ? "activeCalenderSubHeader" : ""}`} onClick={() => setActiveTaskProgressBar('In Progress')}>In Progress<span className='sub_header_count'>{tasksCount.tasksInProgressCount}</span></p>
                            <p className={` calender_sub_header cal_sub_hd ${ActiveTaskProgressBar === "Completed" ? "activeCalenderSubHeader" : ""}`} onClick={() => setActiveTaskProgressBar('Completed')}>Completed<span className='sub_header_count'>{tasksCount.tasksCompletedCount}</span></p>

                            <select id="" name="" className='calender_sub_header task_select' value={ActiveTaskProgressBar} onChange={(e) => setActiveTaskProgressBar(e.target.value)}>
                                <option value="next_up">Next Up ({tasksCount.tasksNextUpCount})</option>
                                <option value="In Progress">In Progress ({tasksCount.tasksInProgressCount})</option>
                                <option value="Completed">Completed ({tasksCount.tasksCompletedCount})</option>
                            </select>

                        </div>
                        <div className='task_box_container'>
                            {
                                taskData.length > 0 ?
                                    taskData.map((task) => {
                                        return (
                                            <div className='task_card' key={task.id}>
                                                <div className='task_header'>
                                                    <h3>{task.data.task_name}</h3>
                                                    <div>
                                                        <FontAwesomeIcon icon={faPenToSquare} className='icons' onClick={() => handleTaskEdit(task.id, task.data)} style={{ display: `${task.data.status === 'Completed' ? 'none' : ''}` }} />
                                                        <FontAwesomeIcon icon={faDeleteLeft} className='icons' onClick={() => handleTaskDelete(task.id)} />
                                                    </div>
                                                </div>
                                                <p>{task.data.task_desc}</p>
                                                <div className='task_card_footer'>
                                                    <p className='meeting_card_time'>{task.data.date}</p>

                                                    <p className='meeting_card_time' style={{ display: `${task.data.status === 'Completed' ? 'inline' : 'none'}` }}>{task.data.status}</p>

                                                    <p style={{ display: `${task.data.status === 'Completed' ? 'none' : 'inline'}` }} onClick={() => handleTaskProgress(task.id, task.data.status === 'next_up' ? 'In Progress' : 'Completed')}><button className='progress_btn'>{`${task.data.status === 'next_up' ? 'In Progress' : 'Completed'}`}</button></p>
                                                </div>
                                            </div>
                                        );
                                    })
                                    :
                                    <span>No Task is Available</span>
                            }
                        </div>
                    </div>
                </div>
                <div className='calender_container'>
                    <div className='calender_header'>
                        <h2 className='task_title'>Calender</h2>
                        <div className='calender_sub_header_container'>
                            {/*  */}
                            <p className={` calender_sub_header ${calenderSubHearderState === "holidays" ? "activeCalenderSubHeader" : ""}`} onClick={() => setCalenderSubHearderState('holidays')}>Events & Holidays</p>
                            <p className={` calender_sub_header ${calenderSubHearderState === "meetings" ? "activeCalenderSubHeader" : ""}`} onClick={() => setCalenderSubHearderState('meetings')}>Meetings</p>
                        </div>
                    </div>
                    <div className='calendar_box'>
                        <Calendar onChange={setDate} value={date} onActiveStartDateChange={(data) => setCurrentMonth(data.activeStartDate.getMonth() + 1)} />
                    </div>
                    <div className='meetings_holidays_container'>
                        {
                            calenderSubHearderState === "holidays" ?
                                eventsHodidays.map((data) => {
                                    return (
                                        <div className='meeting_card' key={data.EventName}>
                                            <span className='meeting_card_title'>{data.EventName}</span>
                                            <span className='meeting_card_time'>{new Date('20' + data.Date.split('-').reverse().join('-')).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric', weekday: 'long' })}</span>
                                        </div>
                                    )
                                }) :
                                <div className='meeting_card'>
                                    <span className='meeting_card_title'>Meeting with Group</span>
                                    <span className='meeting_card_time'>{date.toDateString()}</span>
                                </div>
                        }
                    </div>
                </div>
            </div >
        </>
    )
}

export default CalenderPage

// get holidays data from this site
// https://currentaffairs.adda247.com/holidays-of-india-2023-gazetted-restricted-and-observances/